import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotelsComponent } from './hotels.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [HotelsComponent],
    exports: [HotelsComponent],
    imports: [CommonModule, RouterModule, TranslateModule.forChild(), LocalizeRouterModule.forChild([])],
    providers: []
})
export class HotelsModule {}
